export enum ITrackingType {
  onTime = 'onTime',
  runningLate = 'runningLate',
  notTracking = 'notTracking',
}
